export default __webpack_public_path__ + "static/media/pause.0107b904.svg";